/**
 * Parses a location string into a path array.
 * Handles array bracket notation and the .data.statements special case.
 *
 * "form_1040.extraction[0].extractedData.taxYear"
 *  → ["form_1040", "extraction", "0", "extractedData", "taxYear"]
 */
export const parsePath = (location: string): string[] => {
    let normalized = location;
    if (normalized.endsWith('.data.statements')) {
        normalized = normalized.replace('.data.statements', '.data');
    }
    return normalized.replace(/\[(\d+)\]/g, '.$1').split('.');
};

/**
 * Immutably sets a value at a nested path, using structural sharing.
 * Only objects along the path get new references — siblings are untouched.
 *
 * Unlike cloneDeep + lodash.set, this preserves referential equality
 * for all parts of the tree that weren't modified.
 */
/**
 * Reads a value at a nested path, returning undefined if any segment is missing.
 */
export const getByPath = (obj: any, path: string[]): any =>
    path.reduce((current, key) => (current == null ? undefined : current[key]), obj);

export const setImmutable = (obj: any, path: string[], value: any): any => {
    if (path.length === 0) return value;
    const [head, ...rest] = path;
    const index = Number(head);
    if (Array.isArray(obj) && !Number.isNaN(index)) {
        const newArr = [...obj];
        newArr[index] = setImmutable(obj[index], rest, value);
        return newArr;
    }
    return { ...obj, [head]: setImmutable(obj?.[head], rest, value) };
};
